export const COPY_TEXT = 'Copied to clipboard!';
export const FAILED_TO_SAVE = 'Failed to save the update. Please try again';
export const NECESSITY_TO_RESET_PASSWORD = `Your account is currently in 'Pending' status. Please enter your Username to start the password reset process and regain access to the system.`;
